// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"638":"1a6e33ed","646":"cd9c8db2","744":"905bdefc","759":"f6a6a36c","881":"998d893b","940":"acf889c8"}[chunkId] + ".chunk.js";
};